import { useBlocNext } from "@blac/react";
import { getLocalTimeZone, now } from "@internationalized/date";
import React, { FC } from "react";
import { GLP1_REFILL_QUESTIONNAIRE_ID } from "src/constants/misc";
import translate from "src/lib/translate";
import { KnownProgram } from "src/state/ProgramBloc/ProgramBloc";
import { taskManagementState } from "src/state/state";
import CustomQuestionnaire from "../CustomQuestionnaire/CustomQuestionnaire";
import Loader from "../Loader/Loader";
import WeightForm from "../WeightForm/WeightForm";
import Glp1RefillBloc from "./Glp1RefillBloc";

const Glp1RefillForm: FC<{ onComplete: () => void }> = (props) => {
  const hours = 72;

  const [{ loading, hasWeightReading, error }, { checkWeightReading }] =
    useBlocNext(Glp1RefillBloc, {
      onMount: (bloc) => {
        void bloc.checkWeightReading();
      }
    });

  const refreshTasks = () => {
    void taskManagementState.loadProgramTasks(KnownProgram.CARE);
  };

  const handleQuestionnaireCompleted = () => {
    props.onComplete();
    refreshTasks();
  };

  return (
    <div>
      {loading && <Loader active fixed />}
      {!loading && (
        <>
          {!hasWeightReading && (
            <WeightForm
              onComplete={() => void checkWeightReading()}
              text={translate("valueRequirements.lastHours", {
                hours
              })}
              minDate={now(getLocalTimeZone()).subtract({
                hours
              })}
              error={error}
            />
          )}
          {hasWeightReading && (
            <CustomQuestionnaire
              id={GLP1_REFILL_QUESTIONNAIRE_ID}
              onLastStepCompleted={handleQuestionnaireCompleted}
              preventLoadingUserAnswers={true}
              onDataSent={refreshTasks}
            />
          )}
        </>
      )}
    </div>
  );
};

export default Glp1RefillForm;
